/**
 * @ngdoc Controller
 * @name GeofenceSettingsController
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('GeofenceSettingsController', GeofenceSettingsController);

    /**
     * @constructor
     * @ngInject
     */
    function GeofenceSettingsController(
        $log,
        $scope,
        $state,
        $q,
        $stateParams,
        InstallationsService,
        ApiService,
    ) {
        $log.info('GeofenceSettingsController');

        $q.all([
            InstallationsService.getInstallation($stateParams.id),
        ]).then(function (result) {
            var installation = result[0];

            redirectUnauthorizedUser(installation);

            try {
                $scope.options = {
                    enable: installation.geofenceEnabled,
                    geofence: JSON.parse(installation.geofence)
                };
            } catch (error) {
                $scope.options = {
                    enable: false,
                    geofence: null
                };
            }

            $scope.map = {
                bounds: {},
                control: {},
                center: {
                    latitude: installation.data.lt ? installation.data.lt.rawValue : null,
                    longitude: installation.data.lg ? installation.data.lg.rawValue : null
                },
                coords: {
                    latitude: installation.data.lt ? installation.data.lt.rawValue : null,
                    longitude: installation.data.lg ? installation.data.lg.rawValue : null
                },
                zoom: 7,
            };

            $scope.save = function () {
                ApiService.installationSettings($stateParams.id, {
                    geofenceEnabled: $scope.options.enable,
                    geofence: $scope.options.geofence ? JSON.stringify($scope.options.geofence) : null,
                }).then(function () {
                    //Update installation without reloading
                    installation.geofenceEnabled = $scope.options.enable;
                    installation.geofence = $scope.options.geofence ? JSON.stringify($scope.options.geofence) : null;
                });
            };

            $scope.reset = function () {
                if ($scope.options.geofence || $scope.options.enable) {
                    $scope.options.geofence = null;
                    $scope.options.enable = false;
                }
            }
        });

        const redirectUnauthorizedUser = (installation) => {
            if (!installation.view_permissions.update_settings) {
                InstallationsService.redirectUnauthorizedUser(installation);
            }
        }

        $scope.onGeofenceChanged = function (e) {
            $scope.options.geofence = e;
            $scope.options.enable = e !== null && e !== undefined;
        }
    }
})();
